import * as route from '../constants/routes';

export const sidebarMenuItems = [
  ['Counters', route.COUNTERS_PATH],
  ['Users', route.USERS_PATH],
  ['Profile', route.PROFILE_PATH],
  ['News', route.NEWS_PATH],
  ['Style Module', route.STYLE_MODULE_PATH],
];
